<template>
    <b-modal
        v-model="modalOpen"
        centered
        scrollable
        size="lg"
        style="width: 100px"
        @hide="onClose"
        @ok="onConfirm"
        :title="`${isUpdate? 'Update':'Create'} Workflow Mappings`"
        header-class="header-nipige-class"
    >
        <b-row>
            <b-col md="6">
                <div class="form-group">
                    <multiselect
                        class="perm_input"
                        :disabled="isUpdate"
                        :options="eventOptions"
                        placeholder="Select Event"
                        label="name"
                        track-by="_id"
                        :multiple="false"
                        v-model="form.event"
                    ></multiselect>
                </div>
            </b-col>
            <b-col md="6">
                <div class="form-group">
                    <multiselect
                        class="perm_input"
                        :options="workflowOptions"
                        placeholder="Select Workflows"
                        :multiple="true"
                        v-model="form.workflow"
                    ></multiselect>
                </div>
            </b-col>
        </b-row>
    </b-modal>
</template>
<script>

import { createMappings, updateMappings } from "@/services/eventWorkflows";

export default {
    name: "manage-events",
    data() {
        return {
            modalOpen: false,
            workflow: {},
            form: {
                event: "",
                workflow: [],
            }
        };
    },
    props: {
        mapping: {
            type: Object,
            default: () => ({}),
        },
        events: {
            type: Array,
            default: () => ([]),
        },
        workflows: {
            type: Array,
            default: () => ([]),
        },
        open: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.modalOpen = this.open;
        if (this.mapping.eventId) {
            this.form.event = this.events.find((e) => e._id === this.mapping.eventId);
        }
        if (this.mapping.workflowId) {
            this.form.workflow = this.mapping.workflowId;
        }
    },
    computed: {
      isUpdate() {
        return !!(this.mapping && this.mapping.eventId);
      },
      workflowOptions() {
        return this.workflows.map((workflow) => `${workflow.name}:${workflow.version}`);
      },
      eventOptions() {
        return this.events.map((event) => ({
            name: event.name,
            _id: event._id,
        }));
      },
    },
    methods: {
        onClose() {
            this.$emit("close");
        },
        onConfirm() {
            if (this.isUpdate) {
                updateMappings(this.mapping._id, ({
                    workflowId: this.form.workflow,
                })).then(() => {
                    this.$toasted.success("Mappings updated successfully");
                }).catch((err) => {
                    this.$toasted.error("Failed to update mappings");
                })
            } else {
                createMappings({
                    eventId: this.form.event._id,
                    workflowId: this.form.workflow,
                }).then(() => {
                    this.$toasted.success("Mappings created successfully");
                }).catch((err) => {
                    this.$toasted.error("Failed to create mappings");
                })
            }
        },

    },

};
</script>
